var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"com-unorder-line"},_vm._l((_vm.dataInfo.children),function(child,index){return _c(child.cpt,{key:index,tag:"component",attrs:{"data-info":child.data,"article-info":_vm.articleInfo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }